const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
    id: 'en-US'
  },
  // {
  //   languageId: 'chinese',
  //   locale: 'zh',
  //   name: 'Chinese',
  //   icon: 'cn',
  //   id: 'cn'
  // },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Spanish',
    icon: 'es',
    id: 'es-ES'
  },
  {
    languageId: 'dutch',
    locale: 'nl',
    name: 'Dutch',
    icon: 'us',
    id: 'nl-BE'
  },
  {
    languageId: 'german',
    locale: 'de',
    name: 'German',
    icon: 'us',
    id: 'de-DE'
  },
  // {
  //   languageId: 'french',
  //   locale: 'fr',
  //   name: 'French',
  //   icon: 'fr',
  //   id: 'fr'
  // },
  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italian',
    icon: 'it',
    id: 'it-IT'
  },
  // {
  //   languageId: 'saudi-arabia',
  //   locale: 'ar',
  //   name: 'Arabic',
  //   icon: 'sa',
  //   id: 'sa'
  // }

];
export default languageData;
